import React from "react";
import PropTypes from "prop-types";
import Col from "react-bootstrap/lib/Col";
import Row from "react-bootstrap/lib/Row";
import CalendarPart from "../CalendarPart/CalendarPart";
import Advanced from "../Advanced/Advanced";
import RegionsSelect from "../RegionsSelect/RegionsSelect";
import classnames from "classnames";
import css from "./styles.less";
import { isMobileDevice } from "../common/utils.js";

class TitleCalendarPart extends React.Component {
	getCalendarColSize = (numOfBlocks, hasRegionBlock, hasAdvancedBlock) => {
		let colSize = 12 / numOfBlocks;
		if (!hasRegionBlock && hasAdvancedBlock) {
			colSize += 2;
		} else if (hasRegionBlock && hasAdvancedBlock) {
			colSize += 1;
		}

		return colSize;
	};

	getAdvancedBlockColSize = (numOfBlocks, hasAdvancedBlock) => {
		let colSize = 12 / numOfBlocks + 1;
		if (!hasAdvancedBlock) {
			colSize -= 2;
		}

		return colSize;
	};

	getAdvancedBlockColSize = (numOfBlocks, hasRegionBlock) => {
		let colSize = 12 / numOfBlocks - 1;
		if (!hasRegionBlock) {
			colSize -= 1;
		}

		return colSize;
	};

	renderAdvancedComponent = (isPromoCodeBoxVisible,isFixedOpen) => {
		const {
			direction,
			titles,
			LoginLink,
			advancedTitle,
			enablePromoCode,
			enableAgentLogin,
			promoCode,
			onChangePromoCode,
			lockPromocode,
			openDirection,
			isWindowMobileView,
			promoCodeInputIsntFixed
		} = this.props;

		return (
			<Advanced
				direction={direction}
				enableAgentLogin={enableAgentLogin}
				title={advancedTitle}
				titles={titles}
				LoginLink={LoginLink}
				promoCode={promoCode}
				enablePromoCode={enablePromoCode}
				onChangePromoCode={onChangePromoCode}
				isPromoCodeBoxVisible={isPromoCodeBoxVisible}
				isLocked={lockPromocode}
				openDirection={openDirection}
				isFixedOpen={isFixedOpen && !promoCodeInputIsntFixed}
			/>
		);
	};

	render() {
		const {
			checkoutAvailability,
			checkinAvailability,
			availabilityLoading,
			openDirection,
			lang,
			titleStyle,
			direction,
			config,
			titles,
			notValidCalendar,
			notValidRegion,
			enabledRegionSelection,
			searchOptions,
			enablePromoCode,
			enableTitle,
			enableAgentLogin,
			onChangeHotelsRegions,
			selectedOption,
			checkinDate,
			checkoutDate,
			openAllDates,
			focusedInput,
			displayDateFormat,
			onChangeCheckinDate,
			onChangeCheckoutDate,
			onNextMonthClick,
			onPrevMonthClick,
			onFocusChange,
			offlineAvailability,
			lockPromocode,
			isWindowMobileView,
			initialCalendarDate
		} = this.props;

		const styles = {
			title: titleStyle
		};

		const enableAdvanced = enablePromoCode;
		const enableTitleOrAdvanced = enableTitle || enableAdvanced;
		const enableAdvancedBlock = enableTitle;

		let numOfBlocks = 3;
		if (!enableAdvancedBlock) {
			numOfBlocks -= 1;
		}
		if (!enabledRegionSelection) {
			numOfBlocks -= 1;
		}
		const solidPortion = 12 / numOfBlocks;
		const calendarColSize = this.getCalendarColSize(
			numOfBlocks,
			enabledRegionSelection,
			enableAdvancedBlock
		); // numOfBlocks < 3 ? solidPortion : solidPortion + 1;
		const regionColSize = solidPortion;
		const advancedColSize = this.getAdvancedBlockColSize(
			numOfBlocks,
			enabledRegionSelection
		);
		return (
			<div className={classnames(css.titleCalendar, css[direction])}>
				{enableTitleOrAdvanced && (
					<div
						className={
							classnames(
								css.titleHolder,
								enableAdvanced ? css.includeAdvanced : css.verticalCenter
							) +
							" sbox-col-xs-12 sbox-col-sm-12 sbox-col-md-" +
							advancedColSize
						}
					>
						<div className="sbox-row">
							{enableTitle && (
								<div
									className={`${
										css.mainTitle
									} sbox-col-xs-12 sbox-col-md-12 sbox-col-lg-12`}
								>
									<span style={styles.title}>{titles.Title}</span>
								</div>
							)}
							{enableAdvanced && (
								<div
									className={
										css.advancedHolder +
										" sbox-col-xs-12 sbox-col-md-12 sbox-col-lg-12 sbox-hidden-xs sbox-hidden-sm"
									}
								>
									{this.renderAdvancedComponent()}
								</div>
							)}
						</div>
					</div>
				)}

				{enabledRegionSelection && (
					<div
						className={classnames(
							css.regions,
							"sbox-col-xs-12",
							"sbox-col-sm-12",
							"sbox-col-md-" + regionColSize
						)}
					>
						<RegionsSelect
							titles={titles}
							direction={direction}
							enabledRegionSelection={enabledRegionSelection}
							notValid={notValidRegion}
							searchOptions={searchOptions}
							selectedOption={selectedOption}
							onChangeHotelsRegions={onChangeHotelsRegions}
							openDirection={openDirection}
						/>
					</div>
				)}

				<div
					className={classnames(
						css.calendarHolder,
						"sbox-col-xs-12",
						"sbox-col-sm-12",
						"sbox-col-md-" + calendarColSize
					)}
				>
					<CalendarPart
						offlineAvailability={offlineAvailability}
						openDirection={openDirection}
						checkoutAvailability={checkoutAvailability}
						checkinAvailability={checkinAvailability}
						availabilityLoading={availabilityLoading}
						lang={lang}
						direction={direction}
						titles={titles}
						checkinDate={checkinDate}
						checkoutDate={checkoutDate}
						openAllDates={openAllDates}
						focusedInput={focusedInput}
						notValid={notValidCalendar}
						displayDateFormat={displayDateFormat}
						onChangeCheckinDate={onChangeCheckinDate}
						onChangeCheckoutDate={onChangeCheckoutDate}
						onNextMonthClick={onNextMonthClick}
						onPrevMonthClick={onPrevMonthClick}
						onFocusChange={onFocusChange}
						isWindowMobileView={isWindowMobileView}
						initialCalendarDate={initialCalendarDate}
					/>
				</div>

				{enableAdvanced && (
					<div
						className={classnames(
							css.addAdvanced,
							css[direction],
							"sbox-hidden-lg",
							"sbox-hidden-md",
							"sbox-col-xs-12",
							"sbox-col-sm-12"
						)}
					>
						{this.renderAdvancedComponent(isWindowMobileView,true)}
					</div>
				)}
			</div>
		);
	}
}

TitleCalendarPart.propTypes = {
	openDirection: PropTypes.string,
	titleStyle: PropTypes.object,
	direction: PropTypes.oneOf(["left", "right"]),
	isRounded: PropTypes.bool,
	checkinDate: PropTypes.any,
	checkoutDate: PropTypes.any,
	openAllDates: PropTypes.bool,
	checkinAvailability: PropTypes.object,
	checkoutAvailability: PropTypes.object,
	availabilityLoading: PropTypes.bool,
	onChangeCheckinDate: PropTypes.func,
	onChangeCheckoutDate: PropTypes.func,
	config: PropTypes.object,
	enableRegion: PropTypes.bool,
	onChangeHotelsRegions: PropTypes.func,
	onNextMonthClick: PropTypes.func,
	onClickOpenCalendar: PropTypes.func,
	onPrevMonthClick: PropTypes.func,
	titles: PropTypes.object,
	validity: PropTypes.object,
	enabledRegionSelection: PropTypes.bool,
	enableTitle: PropTypes.bool,
	enablePromoCode: PropTypes.bool,
	enableAgentLogin: PropTypes.bool,
	lockPromocode: PropTypes.bool,
	promoCodeInputIsntFixed: PropTypes.bool,
	initialCalendarDate: PropTypes.string
};

TitleCalendarPart.defaultProps = {};

export default TitleCalendarPart;



// WEBPACK FOOTER //
// ./src/components/TitleCalendarPart/TitleCalendarPart.js